import { FC } from "react";
import { MAIN_PRIMARY_1_COLOR } from "shared/consts";

type Props = {
  fill?: string;
};

export const CameraIcon: FC<Props> = ({ fill = MAIN_PRIMARY_1_COLOR }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4191 4.74725C10.6022 4.90996 10.8386 4.99984 11.0835 4.99984H13.3335C13.5176 4.99984 13.6668 5.14908 13.6668 5.33317V11.3332C13.6668 11.8855 13.2191 12.3332 12.6668 12.3332H3.3335C2.78121 12.3332 2.3335 11.8855 2.3335 11.3332V5.33317C2.3335 5.14908 2.48273 4.99984 2.66683 4.99984H4.91683C5.16174 4.99984 5.39814 4.90996 5.58119 4.74725L6.51287 3.91909C6.69592 3.75638 6.93231 3.6665 7.17723 3.6665H8.8231C9.06801 3.6665 9.30441 3.75638 9.48746 3.91909L10.4191 4.74725ZM2.66683 3.99984H4.91683L5.8485 3.17168C6.2146 2.84626 6.6874 2.6665 7.17723 2.6665H8.8231C9.31293 2.6665 9.78572 2.84626 10.1518 3.17169L11.0835 3.99984H13.3335C14.0699 3.99984 14.6668 4.59679 14.6668 5.33317V11.3332C14.6668 12.4377 13.7714 13.3332 12.6668 13.3332H3.3335C2.22893 13.3332 1.3335 12.4377 1.3335 11.3332V5.33317C1.3335 4.59679 1.93045 3.99984 2.66683 3.99984ZM8.00016 6.99984C8.73654 6.99984 9.3335 7.59679 9.3335 8.33317C9.3335 9.06955 8.73654 9.6665 8.00016 9.6665C7.26378 9.6665 6.66683 9.06955 6.66683 8.33317C6.66683 7.59679 7.26378 6.99984 8.00016 6.99984ZM8.00016 5.99984C9.28883 5.99984 10.3335 7.04451 10.3335 8.33317C10.3335 9.62183 9.28883 10.6665 8.00016 10.6665C6.7115 10.6665 5.66683 9.62183 5.66683 8.33317C5.66683 7.04451 6.7115 5.99984 8.00016 5.99984Z"
      fill={fill}
    />
  </svg>
);